module.exports = __webpack_public_path__ + "static/media/bt.f5f34922.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bt.svg
// module id = 876
// module chunks = 0